<header class="mx-1 my-0 d-flex justify-content-between">
  <div class="d-flex align-items-center">
    <img class="header-logo" [src]="logoSrc" alt="elucidataLogo">
    <h3 class="color-branded-dark heading-title"> Polly
      <sup class="superscript margin-left-icon">TM</sup> {{appHeaderName}}
    </h3>
  </div>

  <div class="d-flex align-items-center">
    <ng-content select="[slot=header-actions]"></ng-content>
    <polly-icon-button icon="polly-icon info color-black" (onClick)="openPollyDocs()" pTooltip="Documentation"
      tooltipPosition="bottom" tooltipStyleClass="qubit">
    </polly-icon-button>
    <polly-icon-button class="upload-btn" icon="polly-icon upload-file color-black" (onClick)="logout()"
      pTooltip="Logout" tooltipPosition="bottom" tooltipStyleClass="qubit">
    </polly-icon-button>
  </div>
</header>